<template>
  <div>
    <title-edit header="TCDC Mini Type" />
    <line-hr />
    <div class="row">
      <v-col cols="12" sm="4" xs="12" class="label">
        <label>type name :</label>
      </v-col>
      <v-col cols="12" sm="5" xs="12">
        <input-text-field :model="form.type_name" color="tcdc_color" @update="updateTypeName" />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="4" xs="12" class="label">
        <label>marker color :</label>
      </v-col>
      <v-col cols="12" sm="5" xs="12">
        <div class="row">
          <div class="col-3">
            <a @click="showChangeColor">
              <v-icon :color="color" style="font-size: 50px">
                fas fa-square
                <span>click select color</span>
              </v-icon>
            </a>
          </div>
          <div style="background: #1d2024;" class="col-5" v-if="show_color">
            <color-picker :color="color" @changeColor="changeColor"></color-picker>
            <div style="padding-top: 10px">
              <v-btn small @click="closeColor">OK</v-btn>
            </div>
          </div>
        </div>
      </v-col>
    </div>
    <line-hr />
    <command-button @delete-info="deleteMiniType" @save-info="saveMiniType" @save-close="saveClose"></command-button>
  </div>
</template>

<script>
import InputTextField from "../../../components/Input/InputTextField";
import colorPicker from "@caohenghu/vue-colorpicker";
import TitleEdit from "../../../components/TitleHeader/TitleEdit";
import LineHr from "../../../components/Icon/line-hr";
import DeleteButton from "../../../components/Button/DeleteButton";
import PreviewButton from "../../../components/Button/PreviewButton";
import SaveButton from "../../../components/Button/SaveButton";
import { mapState } from "vuex";
import Swal from 'sweetalert';
import {
  permissionMiniTCDCType, role,
} from "../../../util/Permission";
import CommandButton from "../../../components/Layout/CommandButton";
export default {
  name: "MiniTypeEdit",
  components: {
    CommandButton,
    SaveButton,
    PreviewButton,
    DeleteButton,
    LineHr,
    TitleEdit,
    InputTextField,
    colorPicker
  },
  data() {
    return {
      color: "#59c7f9",
      show_color: false,
      permission : null,
    };
  },
  computed: {
    permissionMiniTCDCType,
    ...mapState({
      form: state => {
        return state.MiniType.form;
      }
    })
  },
  created() {
    this.permission = role;
    if (this.form.type_id) {
      this.color = this.form.marker_color;
    }
  },
  methods: {
    changeColor(color) {
      this.color = color.hex;
    },
    showChangeColor() {
      this.show_color ? (this.show_color = false) : (this.show_color = true);
    },
    closeColor() {
      this.show_color = false;
    },
    saveClose() {
      this.form.marker_color = this.color;
      this.$store
              .dispatch("MiniType/saveMiniType", {
                id: this.form.type_id,
                data: this.form
              })
              .then(res => {
                Swal(res.response_msg);
                if (res.response_code == 200) {
                  this.goToMiniTypeTable();
                }
              });
    },
    saveMiniType() {
      this.form.marker_color = this.color;
      this.$store
        .dispatch("MiniType/saveMiniType", {
          id: this.form.type_id,
          data: this.form
        })
        .then(res => {
          Swal(res.response_msg);
        });
    },
    deleteMiniType() {
      this.$store.dispatch("MiniType/deleteMiniType", this.form.type_id).then(res => {
        Swal(res.response_msg);
        if (res.response_code == 200) {
          this.goToMiniTypeTable();
        }
      });
    },
    goToMiniTypeTable() {
      this.$router.push("/branch/tcdc-mini-type");
    },
    updateTypeName(val) {
      this.form.type_name = val;
    }
  }
};
</script>

<style scoped>
.label {
  text-align: right;
}
</style>
